import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ChannelsService } from '../../../infrastructure/services/channels.service';
import { LoaderService } from '../../../infrastructure/services/loader.service';
import { AlertService, GrowlType } from '../../../infrastructure/services/alert.service';
import { HomeChannelComponent } from './home.channel.component';
import { TimelineNegocioConfiguracionComponent } from '../../configuracion/channel/timeline.component';
import { Subscription } from 'rxjs';
import { Translator } from 'angular-translator';
import { Channel } from 'app/infrastructure/model/interfaces/channel.interface';

@Component({
  templateUrl: './detail.channel.component.html',
  styleUrls: ['../../configuracion/subscription/nuevo.subscription.component.css'],
})
export class DetailchannelComponent implements OnInit, OnDestroy {
  channel: Channel;
  // codSistema: string = '';
  // codNegocio: string;
  esNuevo = true;
  checkeandCodigo = false;
  errorCodigo = null;
  completitud = 0;
  subscripcion: Subscription;
  organizationCode: string;
  subscriptionCode:string;
  channelCode:string;

  constructor(public loader: LoaderService,
    private alertService: AlertService,
    private channelsService: ChannelsService,
    private router: Router,
    private aRoute: ActivatedRoute,
    private translator: Translator,
    
    ) { }

  ngOnInit() {
    
    this.aRoute.params.subscribe(param => {
      this.subscriptionCode = param['codsistema'];
      this.channelCode = param['codnegocio'];
      this.organizationCode = param['codorganizacion'];

      this.esNuevo = false;

      if (this.channelCode === undefined) {
        this.esNuevo = true;
        this.channel = {
          channelCode: '',
          organizationCode: this.organizationCode,
          subscriptionCode: this.subscriptionCode,
          descripcion: <string>this.translator.instant('NEGOCIO_NOMBRE'),
        };
        return;
      }

      this.subscripcion = this.channelsService
        .getDetailChannel(this.organizationCode, this.subscriptionCode, this.channelCode)
        .subscribe(data => {
          if (!data) {
            return this.router.navigateByUrl('/soc/404');
          }
          this.channel = data;
          this.inicializarCampos(data);
        });
    });
  }

  ngOnDestroy() {
    if (this.subscripcion) {
      this.subscripcion.unsubscribe();
    }
  }

  validarCodigo() {
    this.errorCodigo = null;

    if (!this.channel.channelCode || this.channel.channelCode.length <= 0) {
      this.errorCodigo =  <string>this.translator.instant('CODE_MUST_HAVE_LEAST_CHARACTER');
      return false;
    }

    if (this.channel.channelCode.length > 10) {
      this.errorCodigo = <string>this.translator.instant('CODE_MUST_HAVE_MAXIMUM_CHARACTERS',{ characters: 10 })
      return false;
    }

    if (this.channel.channelCode.toLocaleLowerCase() === 'nuevo') {
      this.errorCodigo = <string>this.translator.instant('CODCHANNEL_INVALID');
      return false;
    }

    this.channel.channelCode = this.channel.channelCode.toUpperCase();

    return true;
  }

  crearChannel() {
    if (!this.validarCodigo()) {
      return;
    }

    this.checkeandCodigo = true;

    // Check para ver que el codigo de negocio no esta usado
    this.channelsService.getDetailChannel(this.organizationCode, this.channel.subscriptionCode, this.channel.channelCode)
      .subscribe(res => {
        this.checkeandCodigo = false;
        // Si el codigo ya existe, no puedo crear un sistema
        if (res !== null) {
          this.errorCodigo = <string>this.translator.instant('CODCHANNEL_EXISTS');
          return false;
        }

        // Creo el sistema
        this.channelsService
          .crearDesdeUnCodigo(this.channel)
          .then(() => {
            this.alertService.showGrowl({
              type: GrowlType.SUCCESS,
              body: 'NEGOCIO_CREADO_CORRECTAMENTE',
            });
            this.router.navigate([`soc/organizations/${this.organizationCode}/subscriptions/${this.channel.subscriptionCode}/channels/${this.channel.channelCode}/edit`]);
          });
      });
  }

  editarDescripcion(nuevoTexto) {
    this.channel.descripcion = nuevoTexto;
    this.editarChannel({ descripcion: nuevoTexto });
  }

  editarDescripcionExt(nuevoTexto) {
    this.channel.descripcionExt = nuevoTexto;
    this.editarChannel({ descripcionExt: nuevoTexto });
  }

  /**
   * Actualiza la Imagen del sistema en el backend
   */
  editarImagen(nuevaImagen) {

    this.channel.imagen = nuevaImagen.imagenBase64;

    this.editarChannel({ imagen: nuevaImagen.imagenBase64 });
  }

  private editarChannel(cambios) {
    this.channelsService.editar(this.channel.organizationCode, this.channel.subscriptionCode, this.channel.channelCode, cambios)
      .then(data => {
        this.inicializarCampos(data);
        this.alertService.showGrowl({
          type: GrowlType.SUCCESS,
          body: 'EDITADO_CORRECTAMENTE',
        });
      });
  }

  private inicializarCampos(data) {
    this.completitud = data.completitud ? JSON.parse(data.completitud).porcentaje : 0;
    this.channel.fechaActualizacion = data.fechaActualizacion;
    this.channel.modificado = data.modificado;
    this.channel.urlImage = data.urlImage;
  };
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/channels/detalle/detail.channel.component.ts